/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly firstPhotoWebPath: string | null;
    } | null> | null;
    readonly " $refType": "PdpSharedIconBubbleEmail_item";
};
export type PdpSharedIconBubbleEmail_item$data = PdpSharedIconBubbleEmail_item;
export type PdpSharedIconBubbleEmail_item$key = {
    readonly " $data"?: PdpSharedIconBubbleEmail_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubbleEmail_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '46be1527f7f9487b857817aa4c05e5be';
export default node;
